import { ChainId } from '@donaswap/sdk'

const CHAIN_MAPPING = {
  // [ChainId.FIRECHAIN]: 'fire',
  // [ChainId.ETHEREUM]: 'ethereum',
  [ChainId.BSC]: 'bsc',
  // [ChainId.POLYGON]: 'polygon',
  // [ChainId.POLYGON_MUMBAI]: 'polygonMumbai',
  // [ChainId.CRO]: 'cro',
  // [ChainId.CRO_TESTNET]: 'croTestnet',
  // [ChainId.AVALANCHE]: 'avalanche',
  // [ChainId.AVALANCHE_FUJI]: 'avalancheFuji',
  // [ChainId.FANTOM_OPERA]: 'fantomOpera',
  // [ChainId.FANTOM_TESTNET]: 'fantomTestnet',
  // [ChainId.CELO]: 'celo',
  // [ChainId.CELO_ALFAJORES]: 'celoAlfajores',
  // [ChainId.OPTIMISM]: 'optimism',
  // [ChainId.OPTIMISM_GOERLI]: 'optimismGoerlie',
  // [ChainId.SHIBARIUM]: 'shibarium',
  // [ChainId.SHIBARIUM_TESTNET]: 'shibariumTestnet',
  // [ChainId.PULSECHAIN]: 'pulsechain',
  // [ChainId.PULSECHAIN_TESTNET]: 'pulsechainTestnet',
  // [ChainId.XEN]: 'xen',
  // [ChainId.XEN_DEVNET]: 'xenDevnet',
  // [ChainId.HARMONY]: 'harmony',
  // [ChainId.HARMONY_TESTNET]: 'harmonyTestnet',
  // [ChainId.COINEX]: 'coinEx',
  // [ChainId.COINEX_TESTNET]: 'coinExTestnet',
  // [ChainId.DOGECHAIN]: 'dogechain',
  // [ChainId.DOGECHAIN_TESTNET]: 'dogechainTestnet',
  // [ChainId.ETHEREUM_CLASSIC]: 'EthereumClassic',
  // [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'EthereumClassicTestnet',
  // [ChainId.FUSION]: 'fusion',
  // [ChainId.FUSION_TESTNET]: 'fusionTestnet',
  // [ChainId.HECO]: 'heco',
  // [ChainId.HECO_TESTNET]: 'hecoTestnet',
  // [ChainId.KCC]: 'kcc',
  // [ChainId.KCC_TESTNET]: 'kccTestnet',
  // [ChainId.KLAYTN]: 'klaytn',
  // [ChainId.KLAYTN_BAOBAB]: 'klaytnBaobob',
  // [ChainId.OKXCHAIN]: 'okxChain',
  // [ChainId.OKXCHAIN_TESTNET]: 'okxChainTestnet',
  // [ChainId.THETHA]: 'theta',
  // [ChainId.THETHA_TESTNET]: 'thetaTestnet',
  // [ChainId.ULTRON]: 'ultron',
  // [ChainId.ULTRON_TESTNET]: 'ultronTestnet',
  // [ChainId.MOONBEAM]: 'moonbeam',
  // [ChainId.MOONRIVER]: 'moonriver',
  // [ChainId.MOONBASE_ALPHA]: 'moonbaseAlpha',
  // [ChainId.AURORA]: 'aurora',
  // [ChainId.AURORA_TESTNET]: 'auroraTestnet',
  // [ChainId.BOBA]: 'boba',
  // [ChainId.BOBA_GOERLI]: 'bobaGoerli',
  // [ChainId.GNOSIS]: 'gnosis',
  // [ChainId.GNOSIS_CHIADO]: 'gnosisChiado',
  // [ChainId.METIS]: 'metis',
  // [ChainId.METIS_GOERLI]: 'metisGoerli',
  // [ChainId.TELOS]: 'telos',
  // [ChainId.TELOS_TESTNET]: 'telosTestnet',
  // [ChainId.SYSCOIN]: 'syscoin',
  // [ChainId.SYSCOIN_TANENBAUM]: 'syscoinTanenbaum',
  // [ChainId.IOTEX]: 'iotex',
  // [ChainId.IOTEX_TESTNET]: 'iotexTestnet',
  // [ChainId.SHIDEN]: 'shiden',
  // [ChainId.ASTAR]: 'astar',
  // [ChainId.SHIBUNYA]: 'shibunya',
  // [ChainId.FUSE]: 'fuse',
  // [ChainId.FUSE_SPARKNET]: 'fuseSparknet',
  // [ChainId.VELAS]: 'velas',
  // [ChainId.VELAS_TESTNET]: 'velasTestnet',
  // [ChainId.REI]: 'rei',
  // [ChainId.REI_TESTNET]: 'reiTestnet',
  // [ChainId.KEKCHAIN]: 'kekchain',
  // [ChainId.KEKCHAIN_TESTNET]: 'kekchainTestnet',
  // [ChainId.TOMOCHAIN]: 'tomochain',
  // [ChainId.TOMOCHAIN_TESTNET]: 'tomochainTestnet',
  // [ChainId.THUNDERCORE]: 'thundercore',
  // [ChainId.THUNDERCORE_TESTNET]: 'thundercoreTestnet',
  // [ChainId.WANCHAIN]: 'wanchain',
  // [ChainId.WANCHAIN_TESTNET]: 'wanchainTestnet',
  // [ChainId.RSK]: 'rsk',
  // [ChainId.RSK_TESTNET]: 'rskTestnet',
  // [ChainId.ELASTOS]: 'elastos',
  // [ChainId.ELASTOS_TESTNET]: 'elastosTestnet',
  // [ChainId.CONFLUX]: 'conflux',
  // [ChainId.CONFLUX_TESTNET]: 'confluxTestnet',
  // [ChainId.BRISECHAIN]: 'brisebriseTestnet',
  // [ChainId.BRISECHAIN_TESTNET]: 'briseTestnet',
  // [ChainId.MUUCHAIN]: 'muuchain',
  // [ChainId.CANTO]: 'canto',
  // [ChainId.OASIS_EMERALD]: 'oasis',
  // [ChainId.VISION]: 'vision',
  // [ChainId.STEP]: 'step',
  // [ChainId.METER]: 'meter',
  // [ChainId.GODWOKEN]: 'godwoken',
  // [ChainId.CALLISTO]: 'callisto',
  // [ChainId.EVMOS]: 'evmos',
  // [ChainId.BASE]: 'base',
  // [ChainId.KAVA]: 'kava',
  // [ChainId.CLOVER]: 'clover',
  // [ChainId.DEFICHAIN]: 'defichain',
  // [ChainId.BRONOS]: 'bronos',
  // [ChainId.FILECOIN]: 'filecoin',
  // [ChainId.FLARE]: 'flare',
  // [ChainId.TARAXA]: 'taraxa',
  // [ChainId.ARBITRUM_ONE]: 'arbitrum',
  // [ChainId.POLYGON_ZKEVM]: 'polygon_zkevm',
  // [ChainId.ZKSYNC]: 'era',
} as const satisfies Record<number, string>

// use for fetch usd outside of the liquidity pools on PancakeSwap
export const fetchTokenUSDValue = async (chainId: number, tokenAddresses: string[]) => {
  if (!tokenAddresses.length || !CHAIN_MAPPING[chainId]) return new Map<string, string>()

  const list = tokenAddresses.map((address) => `${CHAIN_MAPPING[chainId]}:${address}`).join(',')

  const result: { coins: { [key: string]: { price: string } } } = await fetch(
    `https://coins.llama.fi/prices/current/${list}`,
  ).then((res) => res.json())

  const commonTokenUSDValue = new Map<string, string>()

  Object.entries(result.coins || {}).forEach(([key, value]) => {
    const [, address] = key.split(':')
    commonTokenUSDValue.set(address, value.price)
  })

  return commonTokenUSDValue
}
